// =============================================================================
// Subset check del plano PLATAFORMA — función pura, isomórfica.
//
// Misma lógica que el `isSubset`/`canActorGrant` de
// `apps/worker-api/src/infrastructure/auth/platform-roles.ts`. Vive acá para
// que worker y dashboard compartan EXACTAMENTE el algoritmo (handoff §8: el
// snapshot `assignable` server == `canPlatformDo` cliente debe ser trivial).
//
// Sin imports (más allá de TS): es JS puro. No tocar.
// =============================================================================

/**
 * Forma canónica de los permisos del plano plataforma. Mismo shape que
 * `PlatformPermissions` del server (`platform-roles.ts`); se redeclara acá
 * para no arrastrar imports server-only al paquete compartido.
 */
export type PlatformPermissionsMap = Record<string, string[]>;

/**
 * ¿Puede un actor con `possessed` otorgar/ejecutar `required`?
 *
 * Devuelve `true` sii cada recurso de `required` existe en `possessed` y todas
 * sus acciones están contenidas. Comportamiento idéntico al `isSubset` del
 * server (`platform-roles.ts`):
 *   - `required` vacío → siempre true (no se pide nada).
 *   - Recurso en `required` ausente de `possessed` → false.
 *   - Acción en `required` ausente del array de `possessed[recurso]` → false.
 *
 * No reemplaza enforcement server-side. El dashboard la usa para anotar la UI
 * (`assignable`, botones habilitados); el server SIEMPRE re-chequea con su
 * propia copia antes de mutar.
 */
export function canPlatformDo(
  possessed: PlatformPermissionsMap,
  required: PlatformPermissionsMap,
): boolean {
  return Object.entries(required).every(([resource, actions]) => {
    const owned = possessed[resource];
    return owned !== undefined && actions.every((action) => owned.includes(action));
  });
}
